import { Field, ID, InputType, ObjectType, registerEnumType } from 'type-graphql'
import { modelOptions, Prop, Severity } from '@typegoose/typegoose'
import GraphQLJSON from 'graphql-type-json'
import { TaskStatusEnum } from '../TaskStatusEnum'
import { generateEntityId } from '../../generateEntityId'
import type { TaskActionHookType } from './TaskActionHookType'

// Register TaskStatusEnum for GraphQL
registerEnumType(TaskStatusEnum, {
  name: 'TaskStatusEnum',
  description: 'The status of a task',
})

/**
 * Configuration for mapping a task status to an action hook.
 * Used to define which action hooks should be executed for specific status transitions.
 */
@ObjectType()
@InputType('TaskStatusActionConfigInput')
@modelOptions({ options: { allowMixed: Severity.ALLOW } })
export class TaskStatusActionConfig {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('tsac') })
  _id: string

  /**
   * The task status that triggers the action hook.
   */
  @Field(() => String)
  @Prop({ type: String, required: true })
  status: TaskStatusEnum

  /**
   * The ID of the action hook to execute.
   */
  @Field(() => String)
  @Prop({ type: String, required: true })
  actionHookId: string

  /**
   * Parameters to pass to the action hook during execution.
   * These values override any default parameters defined in the hook.
   */
  @Field(() => GraphQLJSON, { nullable: true })
  @Prop({ type: Object })
  parameters?: Record<string, unknown>

  /**
   * The resolved action hook metadata.
   * This field is populated by a field resolver and is not stored in the database.
   */
  actionHook?: TaskActionHookType
}
